/** Preview progress is browser-local UI state, never evidence of participation. */
const fallback = new Map<string, string[]>();

export function coursePreviewStorageKey(userId: string, journeyId: string, revision: string) {
  return `jp:course-preview:${userId}:${journeyId}:${revision}`;
}

export function readCoursePreviewProgress(key: string, allowedIds: ReadonlySet<string>): Set<string> {
  let value: unknown = fallback.get(key) ?? [];
  // A failed write can leave an older stored value behind. The pending memory
  // value takes precedence until a later write succeeds.
  if (!fallback.has(key)) {
    try {
      const saved = window.sessionStorage.getItem(key);
      value = saved ? JSON.parse(saved) : [];
    } catch { /* Memory-only preview remains usable when storage is unavailable. */ }
  }
  return new Set(Array.isArray(value) ? value.filter((id): id is string => typeof id === "string" && allowedIds.has(id)) : []);
}

export function writeCoursePreviewProgress(key: string, completed: ReadonlySet<string>) {
  const ids = [...completed];
  try {
    if (ids.length) window.sessionStorage.setItem(key, JSON.stringify(ids));
    else window.sessionStorage.removeItem(key);
    fallback.delete(key);
  } catch {
    fallback.set(key, ids);
  }
}
